export default __webpack_public_path__ + "static/media/background-fair.d63bb0bb.svg";